import { MobileOnly } from "@/components/ui/ResponsiveTableList";
import type { BandejaAutorizacionItem } from "@/lib/types";
import { BandejaMobileCard } from "./BandejaMobileCard";

export function BandejaMobileList({ items }: { items: BandejaAutorizacionItem[] }) {
  return (
    <MobileOnly className="flex flex-col gap-3">
      {items.map((it) => (
        <BandejaMobileCard key={it.id} it={it} />
      ))}
    </MobileOnly>
  );
}
